import { memo } from "react";

function Icon_RigFracRecentActivity() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true">
      <path d="M2 2V26H16V28H0V2H2Z" fill="currentColor" />
      <rect x="4" y="3" width="22" height="3" fill="currentColor" />
      <rect x="4" y="9" width="17" height="3" fill="currentColor" />
      <rect x="4" y="15" width="12" height="3" fill="currentColor" />
      <rect x="4" y="21" width="8" height="3" fill="currentColor" />
      <path
        d="M23 18C25.7571 18 28 20.2429 28 23C28 25.7571 25.7571 28 23 28C20.2429 28 18 25.7571 18 23C18 20.2429 20.2429 18 23 18ZM23 19.75C22.5858 19.75 22.25 20.0858 22.25 20.5V23.3105L24.4697 25.5303C24.7626 25.8232 25.2374 25.8232 25.5303 25.5303C25.8232 25.2374 25.8232 24.7626 25.5303 24.4697L23.75 22.6895V20.5C23.75 20.0858 23.4142 19.75 23 19.75Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default memo(Icon_RigFracRecentActivity);
